import script from "./CodeSection.vue?vue&type=script&lang=js"
export * from "./CodeSection.vue?vue&type=script&lang=js"

import "./CodeSection.vue?vue&type=style&index=0&id=b678641c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b678641c"]])

export default __exports__